var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-wrapper",class:{ blocking: _vm.blocking, 'd-none': !_vm.shown }},[_c('div',{staticClass:"overlay"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }